import { createReducer } from '@reduxjs/toolkit';

import getOrderByPo, { clearErrorGetOrderByPo, clearGetOrderByPo } from '../../thunks/general/getOrderByPo';

const initialState = {
  loading: false,
  error: null,
  orderData: {},
};

const getOrderByPoReducer = createReducer(initialState, {
  [getOrderByPo.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [getOrderByPo.fulfilled]: (state, { payload }) => ({
    ...state,
    orderData: payload,
    loading: false,
  }),
  [clearErrorGetOrderByPo]: (state) => ({
    ...state,
    error: null
  }),
  [clearGetOrderByPo]: () => initialState,
  [getOrderByPo.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
  }),
});

export default getOrderByPoReducer;
